import { Controller } from "@hotwired/stimulus"

// Removes the closest item row from the review form. Tapping the X
// next to an item deletes its block of inputs from the DOM, so the
// subsequent form submit persists the edited list without that row.
export default class extends Controller {
  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-pantry-row]")
    if (row) row.remove()
  }
}
